import type { HandleFileUploadChangeValue } from '../hook/useFileUploadHandler'

export type MultiFileInputItem = Partial<HandleFileUploadChangeValue> &
  Pick<HandleFileUploadChangeValue, 'fileName'>

export const upsertMultiFileItem = (
  currentItems: MultiFileInputItem[],
  item: Partial<HandleFileUploadChangeValue>,
  fileName: string,
) => {
  // add / update file
  let isUpdated = false
  const newItems = currentItems.map((valueItem) => {
    if (valueItem.fileName === fileName) {
      isUpdated = true
      return { fileName, ...item }
    }
    return valueItem
  })

  if (!isUpdated) {
    newItems.push({
      fileName,
      ...item,
    })
  }

  return newItems
}

export const removeMultiFileItem = (
  currentItems: MultiFileInputItem[],
  itemFileName: string,
) => {
  return currentItems.filter(({ fileName }) => fileName !== itemFileName)
}

export const removeMultiFileItemAtIndex = (
  currentItems: MultiFileInputItem[],
  index?: number,
) => {
  if (index === undefined) {
    return currentItems
  }

  return [...currentItems.slice(0, index), ...currentItems?.slice(index + 1)]
}
